import * as React from 'react';
import styled, { StyledFunction } from 'styled-components';
import * as ChatBubbleIcon from 'react-icons/lib/io/chatbubble';
import * as PhoneIcon from 'react-icons/lib/io/iphone';
import { media, withMedia, WithMediaProps, styledWithProps } from '../../util/styles';
import { MobileCtaSettings } from '../../typedefs/store';
import { darken } from 'polished';

interface Props extends WithMediaProps {
    ctaClicked: () => void;
    smsCtaClicked: () => void;
    settings: MobileCtaSettings;
}

class MobileCta extends React.Component<Props, {}> {
    constructor(props: any) {
        super(props);
    }

    ctaClicked = (e: React.MouseEvent<HTMLElement>) => {
        e.preventDefault();
        e.stopPropagation();
        this.props.ctaClicked();
    };

    handleSmsClick = () => {
        this.props.smsCtaClicked();
    };

    renderIcon() {
        const { isMobile, settings } = this.props;

        const smsPhone = settings.smsPhone ? settings.smsPhone.replace(/[^+-\d]/g, '') : null;

        return (
            <Positioner bottom={settings.ctaBottomMargin} className="conversations-cta-mobile">
                {smsPhone && (
                    <Tab settings={settings} onClick={this.handleSmsClick} href={`sms:${smsPhone}`}>
                        <PhoneIcon size={32} style={{ marginRight: 10 }} />
                        <div>Text</div>
                    </Tab>
                )}
                <Tab settings={settings} onClick={this.ctaClicked} href="#">
                    <ChatBubbleIcon size={32} style={{ marginRight: 10 }} />
                    <div>Chat</div>
                </Tab>
            </Positioner>
        );
    }

    render() {
        const { isMobile, isDesktop } = this.props;
        const shouldShow = isDesktop || isMobile;
        return shouldShow && this.renderIcon();
    }
}

export const BaseMobileCta = MobileCta;
export default withMedia(MobileCta);

const Positioner = styledWithProps<{ bottom: number }>(styled.div)`
    position: fixed;
    bottom: ${props => props.bottom}px;
    right: 0;
    left: 0;
    display: flex;
    align-items: flex-center;
    z-index: 1220000;
`;

const Tab = styledWithProps<{ settings: MobileCtaSettings }>(styled.a)`
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 5px;
    background-color: ${props => props.settings.ctaBackgroundColor};
    color: ${props => props.settings.ctaForegroundColor};
    &:hover, &:active {
        color: ${props => props.settings.ctaForegroundColor};
    }
    font-size: 16px;
    text-transform: uppercase;
    text-decoration: none;
    margin-right: 5px;
    border-radius: 0 3px 0 0;
    border-top: 4px solid;
    border-top-color: ${props => darken(0.2, props.settings.ctaBackgroundColor)};
    &:last-child {
        margin-right: 0;
        border-radius: 3px 0 0 0;
    }
`;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Cta/Mobile.tsx